// ignore-string-externalization

import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { withRouter } from '../shared/lib/nextCompat';
import Root from './Root';
import { GlobalStyles } from '@spotify-internal/encore-web-v5';
import { Configuration } from '@spotify-internal/remote-config-properties';
import { RemoteConfigProvider } from '@spotify-internal/remote-config-integration-react';
import { getConfiguration } from '../../../features/src/RemoteConfig/RemoteConfig';

const RoutedRoot = withRouter(Root);

const LegacyPage = (ctx: $TSFixMe) => {
  const { store, props, Component } = ctx;
  const [config, setConfig] = useState<Configuration | null>(null);
  useEffect(() => {
    getConfiguration().then(setConfig);
  }, []);

  return (
    // @ts-ignore
    <RemoteConfigProvider configuration={config}>
      {/* @ts-ignore */}
      <Provider store={store}>
        <RoutedRoot>
          <GlobalStyles />
          <Component {...props} />
        </RoutedRoot>
      </Provider>
    </RemoteConfigProvider>
  );
};

export default LegacyPage;
